export * from './comunicacionController.service';
import { ComunicacionControllerService } from './comunicacionController.service';
export * from './comunicacionEstadoController.service';
import { ComunicacionEstadoControllerService } from './comunicacionEstadoController.service';
export * from './comunicacionHistorialController.service';
import { ComunicacionHistorialControllerService } from './comunicacionHistorialController.service';
export * from './comunicacionesCategoriaController.service';
import { ComunicacionesCategoriaControllerService } from './comunicacionesCategoriaController.service';
export * from './comunicacionesSubcategoriaController.service';
import { ComunicacionesSubcategoriaControllerService } from './comunicacionesSubcategoriaController.service';
export * from './comunicacionesTipoController.service';
import { ComunicacionesTipoControllerService } from './comunicacionesTipoController.service';
export * from './helloWorldController.service';
import { HelloWorldControllerService } from './helloWorldController.service';
export const APIS = [ComunicacionControllerService, ComunicacionEstadoControllerService, ComunicacionHistorialControllerService, ComunicacionesCategoriaControllerService, ComunicacionesSubcategoriaControllerService, ComunicacionesTipoControllerService, HelloWorldControllerService];
